import { InjectionToken } from '@angular/core';
import { LocalStorageAuthId } from './local-storage.interface';

export const LOCAL_STORAGE_AUTHID = new InjectionToken<LocalStorageAuthId>(
  'LocalStorageAuthId',
);
